// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"f4f3f7d5","301":"ed1968dd","444":"d20286ef","648":"a9109807"}[chunkId] + ".chunk.css";
};